<script lang="ts">
  import { onMount } from 'svelte';
  import { replace } from 'svelte-spa-router';

  // Redirect inmediato de /  ->  /dashboard. El guard de Dashboard
  // luego decide si lanza a /login.
  onMount(() => {
    replace('/dashboard');
  });
</script>
